import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { Separator } from "@/components/ui/separator";
export default function CartContent() {
  return <section data-section-id="415" id="cart-content" className="bg-background text-foreground py-20 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="mb-12">
          <p className="font-mono text-xs uppercase tracking-widest mb-6" style={{
          color: "var(--primary)"
        }}>
            STEP 01 / 02
          </p>
          <h1 className="font-sans font-default text-5xl sm:text-6xl lg:text-7xl xl:text-[80px] leading-[0.95] tracking-tight mb-6">
            Your <em className="italic font-serif">Order.</em>
          </h1>
          <p className="text-[15px] text-muted-foreground max-w-xl leading-relaxed font-sans">
            Review your selected construction materials before finalizing your request. Our team will process your order shortly.
          </p>
        </div>

        {}
        <div className="relative my-12">
          <Separator className="h-px" style={{
          backgroundColor: "var(--primary)"
        }} />
          <span className="absolute left-0 -top-2.5 px-3 font-mono text-[11px] uppercase tracking-[0.2em]" style={{
          backgroundColor: "var(--background)",
          color: "var(--primary)"
        }}>
            ORDER SUMMARY
          </span>
        </div>

        {}
        <div className="cart-editorial">
          <WooCommerceCartBlock />
        </div>

        <style>{`
          .cart-editorial .wc-block-cart {
            color: var(--foreground);
            font-family: var(--font-sans);
          }
          .cart-editorial .wc-block-cart__main-content,
          .cart-editorial .wp-block-woocommerce-cart-line-items-block {
            background: transparent;
          }
          .cart-editorial table.wc-block-cart-items {
            border-collapse: collapse;
            width: 100%;
          }
          .cart-editorial .wc-block-cart-items__row,
          .cart-editorial tr.wc-block-cart-items__row {
            border-bottom: 1px solid var(--border);
            padding: 24px 0 !important;
          }
          .cart-editorial .wc-block-cart-items__row td {
            padding-top: 24px !important;
            padding-bottom: 24px !important;
            vertical-align: top;
          }
          .cart-editorial .wc-block-cart-item__image img,
          .cart-editorial .wc-block-cart-item__image a {
            width: 96px !important;
            height: 96px !important;
            object-fit: cover;
            border-radius: var(--radius-lg);
          }
          .cart-editorial .wc-block-cart-item__product-name,
          .cart-editorial .wc-block-components-product-name {
            font-family: var(--font-default);
            font-size: 18px;
            font-weight: 500;
            color: var(--foreground);
            text-decoration: none;
          }
          .cart-editorial .wc-block-cart-item__product-metadata,
          .cart-editorial .wc-block-components-product-metadata,
          .cart-editorial .wc-block-components-product-details {
            font-family: var(--font-mono);
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: var(--muted-foreground);
            margin-top: 6px;
          }
          .cart-editorial .wc-block-components-quantity-selector {
            border: 1px solid var(--border);
            border-radius: var(--radius-lg);
            background: transparent;
          }
          .cart-editorial .wc-block-components-quantity-selector__button {
            color: var(--foreground);
            background: transparent;
            transition: color 0.2s ease, background 0.2s ease;
          }
          .cart-editorial .wc-block-components-quantity-selector__button:hover {
            color: var(--primary);
            background: color-mix(in srgb, var(--primary) 12%, transparent);
          }
          .cart-editorial .wc-block-cart-item__remove-link,
          .cart-editorial .wc-block-components-product-name + a {
            font-family: var(--font-mono);
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: var(--muted-foreground);
            text-decoration: none;
            transition: color 0.2s ease;
          }
          .cart-editorial .wc-block-cart-item__remove-link:hover {
            color: var(--primary);
          }
          .cart-editorial .wc-block-components-product-price,
          .cart-editorial .wc-block-cart-item__total-price-and-sale-badge-wrapper {
            font-family: var(--font-default);
            font-size: 18px;
            color: var(--foreground);
          }

          
          .cart-editorial .wc-block-components-sidebar,
          .cart-editorial .wp-block-woocommerce-cart-totals-block {
            background: var(--card);
            color: var(--card-foreground);
            border-radius: var(--radius-lg);
            padding: 32px !important;
          }
          .cart-editorial .wc-block-components-totals-item__label,
          .cart-editorial .wc-block-components-totals-shipping__title {
            font-family: var(--font-mono);
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.15em;
            color: var(--muted-foreground);
          }
          .cart-editorial .wc-block-components-totals-item__value {
            font-family: var(--font-default);
            font-size: 18px;
            color: var(--card-foreground);
          }
          .cart-editorial .wc-block-components-totals-footer-item .wc-block-components-totals-item__value,
          .cart-editorial .wc-block-components-totals-footer-item__value {
            font-size: 28px;
            color: var(--card-foreground);
          }
          .cart-editorial hr,
          .cart-editorial .wc-block-components-totals-wrapper {
            border-color: var(--border);
          }

          
          .cart-editorial .wc-block-cart__submit-button,
          .cart-editorial a.wc-block-cart__submit-button,
          .cart-editorial .wp-block-woocommerce-proceed-to-checkout-block a {
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
            width: 100%;
            background: var(--primary) !important;
            color: var(--primary-foreground) !important;
            font-family: var(--font-mono);
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.15em;
            padding: 18px 28px !important;
            border-radius: var(--radius-lg);
            border: none;
            text-decoration: none;
            transition: background 0.2s ease, transform 0.2s ease;
          }
          .cart-editorial .wc-block-cart__submit-button:hover {
            background: color-mix(in srgb, var(--primary) 88%, black) !important;
            transform: translateY(-1px);
          }

          
          .cart-editorial .wc-block-cart__empty-cart__title,
          .cart-editorial .wp-block-woocommerce-empty-cart-block h2 {
            font-family: var(--font-default);
            font-size: 28px;
            color: var(--foreground);
            text-align: center;
          }
          .cart-editorial .wp-block-woocommerce-empty-cart-block a.wp-block-button__link {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            color: var(--foreground);
            border: 1px solid var(--border);
            font-family: var(--font-mono);
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.15em;
            padding: 14px 24px;
            border-radius: var(--radius-lg);
            transition: background 0.2s ease, border-color 0.2s ease;
          }
          .cart-editorial .wp-block-woocommerce-empty-cart-block a.wp-block-button__link:hover {
            background: color-mix(in srgb, var(--primary) 14%, transparent);
            border-color: var(--primary);
            color: var(--primary);
          }
        `}</style>
      </div>
    </section>;
}